export function createNodeLine(g,pointA, pointB) {
    let a = { x: pointA.x, y: pointA.y, z: pointA.z }
    let b = { x: pointB.x, y: pointB.y, z: pointB.z }
    return { a, b, pointA: g.nodePoint[`${pointA.x},${pointA.y},${pointA.z}`].point, pointB: g.nodePoint[`${pointB.x},${pointB.y},${pointB.z}`].point, distance: betweenTwoPointsDistance(pointA, pointB) }
}
export function betweenTwoPointsDistance(pointA, pointB) {
    let a = pointB.x - pointA.x
    let b = pointB.y - pointA.y
    return Math.sqrt(a * a + b * b)
}
export function findAngle(a1, b1, a2, b2) {
    let x00, y00, x01, y01, x10, y10, x11, y11
    x00 = a1.x; y00 = a1.y;
    x01 = b1.x; y01 = b1.y;
    x10 = a2.x; y10 = a2.y;
    x11 = b2.x; y11 = b2.y

    var dx0 = x01 - x00;
    var dy0 = y01 - y00;
    var dx1 = x11 - x10;
    var dy1 = y11 - y10;
    let angle = Math.atan2(dx0 * dy1 - dx1 * dy0, dx0 * dx1 + dy0 * dy1);
    return Math.floor(angle * 180 / 3.1415926);
}

export function RunNearPoint(nodePoint, nodeLine) {
    Object.values(nodePoint).forEach((d) => {
        d.point.targetDist = Infinity;
        d.point.previousNode = undefined;
        d.point.close = false;
        d.point.colleague = []
    });
    Object.values(nodePoint).forEach((d) => {
        if (d.point.close === false) {
            
            Object.values(nodeLine).forEach((j) => {
                if (d.x === j.pointA.x && d.y === j.pointA.y && d.z === j.pointA.z) {
                    if (j.pointB.x === d.x && j.pointB.y === d.y && j.pointB.z === d.z) {
                    } else {
                        
                        d.point.addColleague({x:j.pointB.x,y:j.pointB.y,z:j.pointB.z});
                        // d.point.addColleague(j.pointB);
                        // debugger
                    }
                }
                if (d.x === j.pointB.x && d.y === j.pointB.y && d.z === j.pointB.z) {
                    if (j.pointA.x === d.x && j.pointA.y === d.y && j.pointA.z === d.z) {
                    } else {
                        d.point.addColleague({x:j.pointA.x,y:j.pointA.y,z:j.pointA.z});
                        // d.point.addColleague(j.pointA);
                    }
                }
            });
        }
        d.point.close = true;
    });
    return { nodeLine, nodePoint }
}
